var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", {}, [
    _c(
      "table",
      { staticClass: "unstriped boss-table-4 pega-th-color-important" },
      [
        _c("thead", [
          _c("tr", [
            _c("th", [
              _vm._v("\n          アプローチした求人\n          "),
              _vm.approachedSummaries.length && !_vm.isPrintPreview
                ? _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: {
                            content:
                              "応募期限内のものは濃色で表示、応募期限外のものは薄色で表示されます。",
                          },
                          expression:
                            "{ content: '応募期限内のものは濃色で表示、応募期限外のものは薄色で表示されます。'}",
                        },
                      ],
                      staticClass: "pega-circle",
                      attrs: { "data-test": "approached" },
                    },
                    [_vm._v("?")]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("th", [_vm._v("オファーDM")]),
            _vm._v(" "),
            _c("th", [_vm._v("スカウト")]),
            _vm._v(" "),
            _c("th", [_vm._v("スカウト特典")]),
          ]),
        ]),
        _vm._v(" "),
        _vm.approachedSummaries.length
          ? _c(
              "tbody",
              _vm._l(_vm.approachedSummaries, function (approachedSummary, i) {
                return _c("tr", { key: i }, [
                  _c(
                    "td",
                    {
                      staticClass: "boss-table-data",
                      attrs: { "data-test": "management-name-" + i },
                    },
                    [
                      _vm._v(
                        "\n          求人ID: " +
                          _vm._s(approachedSummary.job.id) +
                          " " +
                          _vm._s(approachedSummary.job.name) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("td", { staticClass: "boss-center" }, [
                    approachedSummary.offerDm.isSend
                      ? _c(
                          "span",
                          {
                            class: {
                              "pega-gray-color-important":
                                !approachedSummary.offerDm.isEffective,
                            },
                            attrs: { "data-test": "offer-dm-ellipse-" + i },
                          },
                          [_vm._v("●\n          ")]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "boss-center" }, [
                    approachedSummary.scout.isSend
                      ? _c(
                          "span",
                          {
                            class: {
                              "pega-gray-color-important":
                                !approachedSummary.scout.isEffective,
                            },
                            attrs: { "data-test": "scout-ellipse-" + i },
                          },
                          [_vm._v("●\n          ")]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "pega-approached-summary-favor" },
                    _vm._l(
                      approachedSummary.specialFavors,
                      function (specialFavor, j) {
                        return _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: {
                                  content:
                                    _vm.getSpecialFavorTooltip(specialFavor),
                                },
                                expression:
                                  "{ content: getSpecialFavorTooltip(specialFavor)}",
                              },
                            ],
                            key: j,
                            staticClass:
                              "boss-bonus-check-text boss-check-true pega-bonus-check-important",
                            class: {
                              "boss-bonus-end": !specialFavor.isEffective,
                            },
                            attrs: {
                              "data-test": "special-favor-" + i + "-" + j,
                            },
                          },
                          [_vm._v(_vm._s(specialFavor.name))]
                        )
                      }
                    ),
                    0
                  ),
                ])
              }),
              0
            )
          : _c("tbody", { attrs: { "data-test": "no-approached" } }, [
              _vm._m(0),
            ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [_vm._v("アプローチした求人はありません。")]),
      _vm._v(" "),
      _c("td"),
      _c("td"),
      _c("td"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }